import Spinner from 'components/Spinner';
import CustomerDetails from './components/CustomerDetails';
import Header from './components/Header';
import useTransactionDetails from './useTransactionDetails';
import styles from './TransactionDetails.module.scss';
import {get} from 'lodash';
import {useRef} from 'react';
import {format, parseISO} from 'date-fns';

function TransactionDetails() {
  const {data} = useTransactionDetails();
  const printRef = useRef<HTMLDivElement>(null);
  if (!data) return <Spinner />;
  const created_at = format(
    parseISO(data?.transaction_date),
    'MMMM d, yyyy hh:mm a'
  );
  console.log(data);
  return (
    <div className={styles.container}>
      <Header
        printRef={printRef}
        id={String(get(data, 'sequential_order_number', '') || 0)}
      />

      <div className={styles.content}>
        <div className={styles.main_content} ref={printRef}>
          <CustomerDetails
            customer={get(data, 'customer', {})}
            service={data?.service_name || ''}
            source={data?.transaction_origin || ''}
            amount={data?.amount || 0}
            items={data?.list_rx || []}
            card={get(data, 'masked_card_number', '')}
            card_type={data?.card_type || ''}
            payment_method={data?.payment_method}
            created_at={created_at}
            transactionType={data?.transaction_type}
            payer_type={data?.payer_type}
          />
        </div>
      </div>
    </div>
  );
}

export default TransactionDetails;
